<template>
  <v-flex xs12 fill-height class="pagina-curso">
    <header-app></header-app>
    <nav-menu-app></nav-menu-app>
    <nav-buttons-app :mod="mod"></nav-buttons-app>

    <!-- Dynamic routing: See https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes -->
    <div class="contenido">
      <transition name="scroll">
        <component :is="'mod-'+$route.params.unipage+'-app'" class="fill-height"></component>
      </transition>
    </div>
  </v-flex>
</template>
<script>

import mod00 from './mod-00';
import mod01 from './mod-01';
import mod02 from './mod-02';
import mod03 from './mod-03';
import mod04 from './mod-04';
import mod05 from './mod-05';
import mod06 from './mod-06';
import mod07 from './mod-07';
import mod08 from './mod-08';

export default {
  components: {
    'mod-0-app': mod00,
    'mod-1-app': mod01,
    'mod-2-app': mod02,
    'mod-3-app': mod03,
    'mod-4-app': mod04,
    'mod-5-app': mod05,
    'mod-6-app': mod06,
    'mod-7-app': mod07,
    'mod-8-app': mod08,
  },
  data() {
    return {
      mod: {
        modurl: "modulo3"
      }
    }
  },
  computed: {
    currentPage() {
      return Math.floor(this.$route.params.unipage);
    },
    subModName() {
      return this.$store.state.subTema;
    }
  },
  // mounted y updated: Carga el número de pantallas en el store para que las flechas de navegación funcionen
  mounted() {
    this.$store.commit("screenTrack", [this.currentPage, 8]);
    document.getElementsByClassName('pagina-curso')[0].style.backgroundPositionY = 'calc('+this.currentPage+' * -50vh)';
  },
  updated() {
    this.$store.commit("screenTrack", [this.currentPage, 8]);
    document.getElementsByClassName('pagina-curso')[0].style.backgroundPositionY = 'calc('+this.currentPage+' * -50vh)';
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!

@import '../../sass/globals';
.pagina-curso {
  background: url('../../assets/textura-M3.png');
  background-repeat: repeat;
  background-position: center;
  transition: all 2.5s;
  width: 100vw;
  min-height: 100vh;
  overflow-y: none;
  color: white;

  .contenido{
    position: relative;
    margin-left: 50px;
    margin-right: 50px;
    max-width: 100%;
    width: 1200px;
    padding: 10px 10px 10px 10px;
    margin: auto;
    margin-bottom: 75px;
    // background-color: rgba(255,255,255,0.5);
    min-height: calc(100vh - 40px - 1rem - 140px);
    font-family: Gothic;

    @media (max-width: 1100px) {
      margin-left: 85px;
      margin-right: 40px;
      max-width: calc(100% - 120px);    
    }

    @media (max-width: 600px) {
        margin-bottom: 45px;
        margin-left: 0;
        max-width: 100%;
    }
  }

}

.scroll-enter-active, .scroll-leave-active{
  transition: all 1.5s;
  position: absolute;
  width: calc(100% - 20px);
}

.scroll-enter {
  transform: translateY(100vh);
}
.scroll-leave-to {
  transform: translateY(-90vh);
}
</style>
